export default "__VITE_ASSET__a8650d0e__"